import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';
import { FieldReference, FieldReferenceService } from '../../services/field-reference.service';

@Component({
  selector: 'lib-field-reference-input',
  templateUrl: './field-reference-input.component.html',
  styleUrl: './field-reference-input.component.scss',
  standalone: false
})
export class FieldReferenceInputComponent {
  protected fieldReferenceService = inject(FieldReferenceService);
  protected translate = inject(TranslateService);

  fieldReferences: FieldReference[] = [];
  @Input()
  entity: string = '';
  @Input()
  selectedPath: string = '';
  @Output()
  selectedPathChange = new EventEmitter<string>();
  freeText: boolean = false;
  noFieldReference: boolean = false;

  ngOnInit() {
    this.fieldReferenceService
      .getFieldReferences(this.entity)
      .pipe(
        map(fields =>
          fields.map(field => ({
            ...field,
            displayName: `${this.translate.instant(field.name)} (${field.path})`,
            selected: this.selectedPath === field.path
          }))
        )
      )
      .subscribe((data: FieldReference[]) => {
        this.fieldReferences = data;

        if (this.selectedPath && !data.some(f => f.path === this.selectedPath)) {
          this.freeText = true;
        }

        if (data.length === 0) {
          this.noFieldReference = true;
        }
      });
  }

  onSelect(selected: FieldReference) {
    const selectedId: string = selected[0];
    const fieldReference = this.fieldReferences.find(f => f.id === selectedId);

    if (fieldReference) {
      this.selectedPath = fieldReference.path;
      this.selectedPathChange.emit(this.selectedPath);
    } else {
      console.warn('Could not find field reference with id:', selectedId);
      this.selectedPath = '';
      this.selectedPathChange.emit(this.selectedPath);
    }
  }
}
